import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { Translate, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IPassenger } from 'app/shared/model/passenger.model';
import { getEntity, updateEntity, createEntity, reset } from './passenger.reducer';

export const PassengerUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const passengerEntity = useAppSelector(state => state.passenger.entity);
  const loading = useAppSelector(state => state.passenger.loading);
  const updating = useAppSelector(state => state.passenger.updating);
  const updateSuccess = useAppSelector(state => state.passenger.updateSuccess);

  const [formData, setFormData] = useState<any>({
    createdDate: displayDefaultDateTime(),
  });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleClose = () => {
    navigate('/passenger' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
      setFormData({
        createdDate: displayDefaultDateTime(),
      });
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (passengerEntity) {
      setFormData({
        ...passengerEntity,
        createdDate: convertDateTimeFromServer(passengerEntity.createdDate),
      });
    }
  }, [passengerEntity]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const validate = (): boolean => {
    const newErrors: Record<string, string> = {};
    if (!formData.code || formData.code.trim() === '') {
      newErrors.code = 'Code is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [field]: event.target.value });
    if (errors[field]) {
      setErrors({ ...errors, [field]: '' });
    }
  };

  // eslint-disable-next-line complexity
  const saveEntity = () => {
    if (!validate()) {
      return;
    }

    const values = { ...formData };

    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.age !== undefined && typeof values.age !== 'number') {
      values.age = Number(values.age);
    }
    values.createdDate = convertDateTimeFromServer(values.createdDate);

    const entity = {
      ...passengerEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h2">
          <Translate contentKey="jhipsterSampleApplicationApp.passenger.home.createOrEditLabel">Create or edit a Passenger</Translate>
        </Typography>
      </Box>
      <Box component="form" sx={{ '& .MuiTextField-root': { mb: 2 } }} noValidate autoComplete="off">
        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          <Box sx={{ '& .MuiTextField-root': { mb: 2 } }}>
            {!isNew ? (
              <TextField id="passenger-id" name="id" label={translate('global.field.id')} value={formData.id || ''} fullWidth InputProps={{ readOnly: true }} />
            ) : null}
            <TextField
              label={translate('jhipsterSampleApplicationApp.passenger.name')}
              id="passenger-name"
              name="name"
              data-cy="name"
              value={formData.name || ''}
              onChange={handleChange('name')}
              fullWidth
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.passenger.email')}
              id="passenger-email"
              name="email"
              data-cy="email"
              value={formData.email || ''}
              onChange={handleChange('email')}
              fullWidth
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.passenger.mobile')}
              id="passenger-mobile"
              name="mobile"
              data-cy="mobile"
              value={formData.mobile || ''}
              onChange={handleChange('mobile')}
              fullWidth
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.passenger.age')}
              id="passenger-age"
              name="age"
              data-cy="age"
              value={formData.age || ''}
              onChange={handleChange('age')}
              fullWidth
              type="number"
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.passenger.gender')}
              id="passenger-gender"
              name="gender"
              data-cy="gender"
              value={formData.gender || ''}
              onChange={handleChange('gender')}
              fullWidth
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.passenger.nationality')}
              id="passenger-nationality"
              name="nationality"
              data-cy="nationality"
              value={formData.nationality || ''}
              onChange={handleChange('nationality')}
              fullWidth
            />
            <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
              <Button
                component={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/passenger"
                replace
                color="info"
                variant="outlined"
                startIcon={<FontAwesomeIcon icon="arrow-left" />}
              >
                <Translate contentKey="entity.action.back">Back</Translate>
              </Button>
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                onClick={saveEntity}
                disabled={updating}
                variant="contained"
                startIcon={<FontAwesomeIcon icon="save" />}
              >
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PassengerUpdate;
